<template>
  <div class="loading-screen" v-if="isLoading">
    <img src="@/assets/logo-beli.png" alt="Logo" class="loading-logo" />
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-logo {
  width: 300px;
  height: auto;
  max-width: 80%;
  filter: drop-shadow(0 0 20px rgba(59, 130, 246, 0.3));
  animation: loadingPulse 2s infinite;
}

@keyframes loadingPulse {
  0% {
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(59, 130, 246, 0.3));
  }
  50% {
    transform: scale(1.1);
    filter: drop-shadow(0 0 30px rgba(59, 130, 246, 0.5));
  }
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(59, 130, 246, 0.3));
  }
}

@media screen and (max-width: 768px) {
  .loading-logo {
    width: 250px;
  }
}

@media screen and (max-width: 480px) {
  .loading-logo {
    width: 200px;
  }
}

/* Add a loading indicator */
.loading-screen::after {
  content: '';
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 3px;
  background: rgba(59, 130, 246, 0.2);
  border-radius: 3px;
  overflow: hidden;
}

.loading-screen::before {
  content: '';
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: #3B82F6;
  border-radius: 3px;
  animation: loadingBar 1.5s ease-in-out infinite;
  z-index: 1;
}

@keyframes loadingBar {
  0% {
    left: 40%;
    width: 40px;
  }
  50% {
    left: 60%;
    width: 60px;
  }
  100% {
    left: 40%;
    width: 40px;
  }
}
</style>
